<template>
    <!-- 玩家信箱：收件箱/发件箱/写信（玩家间信件，限好友，可附道具） -->
    <el-dialog class="letterwrap" title="信箱" :visible.sync="letterPanelVisible"
        :before-close="letter_panel_dialog_close" append-to-body width="480px">
        <div class="letterwrap-inner" v-loading="loading">
            <div class="letter-tabs">
                <a class="letter-tab" :class="{active: activeTab == 'inbox'}" @click="switchTab('inbox')">收件箱<span v-if="unreadCount > 0" class="tab-badge">{{unreadCount}}</span></a>
                <a class="letter-tab" :class="{active: activeTab == 'outbox'}" @click="switchTab('outbox')">发件箱</a>
                <a class="letter-tab" :class="{active: activeTab == 'write'}" @click="switchTab('write')">写信</a>
            </div>

            <!-- 收件箱 -->
            <div v-show="activeTab == 'inbox'">
                <div class="letter-head">
                    <span class="unread-tip">未读 <b>{{unreadCount}}</b> 封</span>
                    <span class="head-actions">
                        <a class="readall-btn" v-if="unreadCount > 0" @click="readAll">全部已读</a>
                        <a class="claimall-btn" v-if="hasUnclaimed()" @click="claimAll">全部领取</a>
                    </span>
                </div>
                <div class="letter-list" v-if="letters.length > 0">
                    <div v-for="letter in letters" v-bind:key="letter.id"
                        class="letter-item" :class="{ 'letter-unread': letter.isRead == '0' }"
                        @click="openLetter(letter)">
                        <div class="letter-row">
                            <span class="letter-dot" v-if="letter.isRead == '0'"></span>
                            <span class="letter-title">{{letter.title}}</span>
                            <span class="attach-flag" v-if="letter.attachments && letter.attachments.length > 0" title="含附件">📎</span>
                            <span class="letter-from" v-if="letter.letterType == 'player'">{{letter.fromUserName}}</span>
                            <span class="letter-type" :class="'type-' + letter.letterType">{{typeLabel(letter.letterType)}}</span>
                        </div>
                        <div class="letter-content" v-if="openedLetterId == letter.id">{{letter.content}}</div>
                        <div class="attach-box" v-if="openedLetterId == letter.id && letter.attachments && letter.attachments.length > 0">
                            <div class="attach-title">附件</div>
                            <div class="attach-item" v-for="att in letter.attachments" v-bind:key="att.id">
                                <img :src="ossPath + att.imgSrc" :title="att.itemName">
                                <span class="attach-name">{{att.itemName}}<i v-if="att.stackCount > 1">×{{att.stackCount}}</i></span>
                            </div>
                            <div class="attach-claim-row">
                                <a class="attach-claim" v-if="hasUnclaimedIn(letter)" @click.stop="claimAttachment(letter)">领取附件</a>
                                <span class="attach-claimed" v-else>附件已领取</span>
                            </div>
                        </div>
                        <div class="letter-time">{{letter.createTime}}</div>
                    </div>
                </div>
                <div class="noSelected" v-else>信箱空空如也，去广场上逛逛吧</div>
                <div class="letter-page" v-if="total > rows">
                    <el-button size="mini" :disabled="page <= 1" @click="loadList(page - 1)">上一页</el-button>
                    <span class="page-num">{{page}} / {{Math.max(1, Math.ceil(total / rows))}}</span>
                    <el-button size="mini" :disabled="page >= Math.ceil(total / rows)" @click="loadList(page + 1)">下一页</el-button>
                </div>
            </div>

            <!-- 发件箱 -->
            <div v-show="activeTab == 'outbox'">
                <div class="letter-list" v-if="outboxLetters.length > 0">
                    <div v-for="letter in outboxLetters" v-bind:key="letter.id" class="letter-item" @click="openLetter(letter)">
                        <div class="letter-row">
                            <span class="letter-title">{{letter.title}}</span>
                            <span class="attach-flag" v-if="letter.attachments && letter.attachments.length > 0" title="含附件">📎</span>
                            <span class="letter-from">致 {{letter.toUserName || '好友'}}</span>
                            <span class="read-state">{{letter.isRead == '1' ? '已读' : '未读'}}</span>
                        </div>
                        <div class="letter-content" v-if="openedLetterId == letter.id">{{letter.content}}</div>
                        <div class="attach-box" v-if="openedLetterId == letter.id && letter.attachments && letter.attachments.length > 0">
                            <div class="attach-title">附件</div>
                            <div class="attach-item" v-for="att in letter.attachments" v-bind:key="att.id">
                                <img :src="ossPath + att.imgSrc" :title="att.itemName">
                                <span class="attach-name">{{att.itemName}}<i v-if="att.stackCount > 1">×{{att.stackCount}}</i></span>
                            </div>
                            <div class="attach-claim-row">
                                <span class="attach-claimed">{{letter.attachments.every(a => a.isClaimed == '1') ? '对方已领取' : '待对方领取'}}</span>
                            </div>
                        </div>
                        <div class="letter-time">{{letter.createTime}}</div>
                    </div>
                </div>
                <div class="noSelected" v-else>还没有寄出过信件</div>
                <div class="letter-page" v-if="outboxTotal > rows">
                    <el-button size="mini" :disabled="outboxPage <= 1" @click="loadOutbox(outboxPage - 1)">上一页</el-button>
                    <span class="page-num">{{outboxPage}} / {{Math.max(1, Math.ceil(outboxTotal / rows))}}</span>
                    <el-button size="mini" :disabled="outboxPage >= Math.ceil(outboxTotal / rows)" @click="loadOutbox(outboxPage + 1)">下一页</el-button>
                </div>
            </div>

            <!-- 写信 -->
            <div v-show="activeTab == 'write'" class="write-box">
                <div class="write-row">
                    <span class="write-label">收件人：</span>
                    <el-select v-model="writeForm.toUserId" size="mini" filterable placeholder="选择好友" class="write-friend">
                        <el-option v-for="friend in friends" v-bind:key="friend.friendId"
                            :label="friend.friendName" :value="friend.friendId"></el-option>
                    </el-select>
                </div>
                <div class="write-row">
                    <span class="write-label">标题：</span>
                    <el-input v-model="writeForm.title" size="mini" maxlength="50" placeholder="信件标题" class="write-input"></el-input>
                </div>
                <el-input type="textarea" v-model="writeForm.content" maxlength="1000" :rows="5"
                    placeholder="给好友写点什么吧……" class="write-content"></el-input>
                <div class="attach-select">
                    <span class="write-label">附件（最多3件）：</span>
                    <a class="attach-add-btn" @click="openItemPicker">+ 添加附件</a>
                    <span class="attach-chip" v-for="item in selectedItems" v-bind:key="item.itemId">
                        <img :src="ossPath + item.imgSrc" :title="item.itemName">
                        {{item.itemName}}<i v-if="item.stackCount > 1">×{{item.stackCount}}</i>
                        <a class="chip-del" @click="removeSelectedItem(item.itemId)">×</a>
                    </span>
                </div>
                <div class="write-actions">
                    <el-button size="mini" type="primary" :disabled="sending" @click="sendLetter">{{sending ? '发送中…' : '发送'}}</el-button>
                </div>
            </div>
        </div>

        <!-- 附件选择：从背包挑选道具 -->
        <el-dialog class="itempicker" title="选择附件（最多3件）" :visible.sync="itemPickerVisible" append-to-body width="380px">
            <div class="picker-grid" v-loading="pocketLoading">
                <div class="picker-item" v-for="item in pocketItems" v-bind:key="item.itemId"
                    :class="{picked: isPicked(item.itemId), disabled: !isPicked(item.itemId) && selectedItems.length >= 3}"
                    @click="togglePick(item)">
                    <img :src="ossPath + item.imgSrc" :title="item.itemName">
                    <div class="picker-name">{{item.itemName}}</div>
                    <div class="picker-count" v-if="item.stackCount > 1">×{{item.stackCount}}</div>
                </div>
            </div>
            <div class="noSelected" v-if="!pocketLoading && pocketItems.length == 0">背包里没有道具</div>
            <div class="picker-actions">
                <el-button size="mini" @click="itemPickerVisible = false">完成</el-button>
            </div>
        </el-dialog>
    </el-dialog>
</template>

<script>
import {getRequest, postRequest, postJson} from '../../utils/api'
import Message from 'element-ui/lib/message'
export default {
  name: 'letterPanel',
  props: {
    letterPanelVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        loading: false,
        activeTab: 'inbox',
        letters: [],
        total: 0,
        unreadCount: 0,
        page: 1,
        rows: 10,
        openedLetterId: null,
        // 发件箱
        outboxLetters: [],
        outboxTotal: 0,
        outboxPage: 1,
        outboxLoaded: false,
        // 写信
        friends: [],
        friendsLoaded: false,
        writeForm: { toUserId: '', title: '', content: '' },
        selectedItems: [],
        sending: false,
        itemPickerVisible: false,
        pocketItems: [],
        pocketLoading: false,
        // 好友面板"写信"直达时暂存的好友（打开面板时消费）
        pendingWriteTo: null
    };
  },
  watch: {
    letterPanelVisible: {
      handler(newVal) {
        if (newVal === true) {
          if (this.pendingWriteTo) {
            // 好友面板"写信"直达：打开即写信页签并预选收件人
            const friend = this.pendingWriteTo;
            this.pendingWriteTo = null;
            this.activeTab = 'write';
            this.openedLetterId = null;
            this.loadFriends(() => { this.writeForm.toUserId = friend.friendId; });
          } else {
            this.activeTab = 'inbox';
            this.page = 1;
            this.loadList(1);
          }
        }
      }
    }
  },
  methods: {
    letter_panel_dialog_close() {
      this.$emit('letter_panel_dialog_close');
    },
    typeLabel: function(type) {
      const map = {system: '系统', task: '任务', trade: '交易', player: '玩家'};
      return map[type] || '系统';
    },
    switchTab: function(tab) {
      this.activeTab = tab;
      this.openedLetterId = null;
      if (tab == 'inbox') {
        this.loadList(this.page);
      } else if (tab == 'outbox' && !this.outboxLoaded) {
        this.loadOutbox(1);
      } else if (tab == 'write' && !this.friendsLoaded) {
        this.loadFriends();
      }
    },
    loadList: function(page) {
      this.loading = true;
      getRequest('/mail/letter/list', { page: page, rows: this.rows }).then(resp => {
        this.loading = false;
        if (resp.status == 200 && 200 == resp.data.status) {
          const d = resp.data.data || {};
          this.letters = d.list || [];
          this.total = d.total || 0;
          this.unreadCount = d.unreadCount || 0;
          this.page = page;
          this.openedLetterId = null;
        } else {
          Message.error(resp.data.message || '信箱加载失败');
        }
      }, () => {
        this.loading = false;
        Message.error('信箱加载异常');
      });
    },
    openLetter: function(letter) {
      this.openedLetterId = this.openedLetterId == letter.id ? null : letter.id;
      if (letter.isRead == '0') {
        postRequest('/mail/letter/read', {letterId: letter.id}).then(resp => {
          if (resp.status == 200 && 200 == resp.data.status) {
            letter.isRead = '1';
            this.unreadCount = Math.max(0, this.unreadCount - 1);
          }
        }, () => {});
      }
    },
    readAll: function() {
      postRequest('/mail/letter/readAll', {}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          this.letters.forEach(l => { l.isRead = '1'; });
          this.unreadCount = 0;
          Message.success('全部信件已标记为已读');
        } else {
          Message.error(resp.data.message || '操作失败');
        }
      }, () => { Message.error('操作异常'); });
    },
    hasUnclaimedIn: function(letter) {
      return (letter.attachments || []).some(a => a.isClaimed == '0');
    },
    hasUnclaimed: function() {
      return this.letters.some(l => (l.attachments || []).some(a => a.isClaimed == '0'));
    },
    claimAll: function() {
      this.loading = true;
      postRequest('/mail/letter/claimAllAttachment', {}).then(resp => {
        this.loading = false;
        if (resp.status == 200 && 200 == resp.data.status) {
          const d = resp.data.data || {};
          if (d.failLetters > 0) {
            Message.warning('已领取' + d.okLetters + '封信的附件' + (d.items ? '（' + d.items + '）' : '')
              + '；' + d.failLetters + '封失败：' + d.errors);
          } else {
            Message.success('附件全部领取成功' + (d.items ? '：' + d.items : ''));
          }
          this.loadList(this.page);
        } else {
          Message.error(resp.data.message || '领取失败');
        }
      }, () => { this.loading = false; Message.error('领取异常'); });
    },
    claimAttachment: function(letter) {
      postRequest('/mail/letter/claimAttachment', {letterId: letter.id}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          Message.success(resp.data.data || '领取成功');
          this.loadList(this.page);
        } else {
          Message.error(resp.data.message || '领取失败');
        }
      }, () => { Message.error('领取异常'); });
    },
    loadOutbox: function(page) {
      this.loading = true;
      getRequest('/mail/letter/outbox', { page: page, rows: this.rows }).then(resp => {
        this.loading = false;
        if (resp.status == 200 && 200 == resp.data.status) {
          const d = resp.data.data || {};
          this.outboxLetters = d.list || [];
          this.outboxTotal = d.total || 0;
          this.outboxPage = page;
          this.outboxLoaded = true;
          this.openedLetterId = null;
        } else {
          Message.error(resp.data.message || '发件箱加载失败');
        }
      }, () => {
        this.loading = false;
        Message.error('发件箱加载异常');
      });
    },
    /** 供宿主调用（好友面板"写信"按钮）：下次面板打开时直达写信页签并预选收件人 */
    writeTo: function(friend) {
      this.pendingWriteTo = friend;
    },
    loadFriends: function(done) {
      getRequest('/mail/friend/list', {}).then(resp => {
        if (resp.status == 200 && 200 == resp.data.status) {
          const d = resp.data.data || {};
          this.friends = d.list || [];
          this.friendsLoaded = true;
        }
        if (done) done();
      }, () => { if (done) done(); });
    },
    openItemPicker: function() {
      this.itemPickerVisible = true;
      if (this.pocketItems.length == 0) {
        this.pocketLoading = true;
        getRequest('/item/cabinet/openPocket', {}).then(resp => {
          this.pocketLoading = false;
          if (resp.status == 200 && 200 == resp.data.status) {
            // 绑定道具（bind_flag=1，如澡票）不可作为附件，后端托管接口同样硬拦
            this.pocketItems = (resp.data.data.pocketItems || []).filter(i => i.bindFlag != 1);
          } else {
            Message.error('背包加载失败');
          }
        }, () => {
          this.pocketLoading = false;
          Message.error('背包加载异常');
        });
      }
    },
    isPicked: function(itemId) {
      return this.selectedItems.some(i => i.itemId === itemId);
    },
    togglePick: function(item) {
      if (this.isPicked(item.itemId)) {
        this.removeSelectedItem(item.itemId);
      } else {
        if (this.selectedItems.length >= 3) {
          Message.warning('一封信最多附3件道具');
          return;
        }
        this.selectedItems.push(item);
      }
    },
    removeSelectedItem: function(itemId) {
      this.selectedItems = this.selectedItems.filter(i => i.itemId !== itemId);
    },
    sendLetter: function() {
      if (!this.writeForm.toUserId) {
        Message.warning('请选择收件人');
        return;
      }
      if (!this.writeForm.title.trim() || !this.writeForm.content.trim()) {
        Message.warning('标题和内容不能为空');
        return;
      }
      this.sending = true;
      postJson('/mail/letter/playerSend', {
        toUserId: this.writeForm.toUserId,
        title: this.writeForm.title,
        content: this.writeForm.content,
        itemIds: this.selectedItems.map(i => i.itemId)
      }).then(resp => {
        this.sending = false;
        if (resp.status == 200 && 200 == resp.data.status) {
          Message.success('信件已寄出');
          this.writeForm = { toUserId: '', title: '', content: '' };
          this.selectedItems = [];
          this.outboxLoaded = false;
          this.activeTab = 'outbox';
          this.loadOutbox(1);
        } else {
          Message.error(resp.data.message || '发送失败');
        }
      }, () => {
        this.sending = false;
        Message.error('发送异常');
      });
    }
  }
};
</script>

<style scoped>
.letterwrap-inner { padding: 2px 4px; }
.letter-tabs { display: flex; border-bottom: 2px solid #ebeef5; margin-bottom: 8px; }
.letter-tab { padding: 6px 14px; font-size: 14px; color: #606266; cursor: pointer; position: relative; }
.letter-tab.active { color: #409eff; font-weight: bold; border-bottom: 2px solid #409eff; margin-bottom: -2px; }
.tab-badge { background: #f56c6c; color: #fff; font-size: 11px; border-radius: 8px; padding: 0 5px; margin-left: 4px; }
.letter-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.unread-tip { font-size: 13px; color: #606266; }
.unread-tip b { color: #f56c6c; }
.readall-btn { font-size: 12px; color: #409eff; cursor: pointer; }
.head-actions { display: flex; align-items: center; gap: 10px; }
.claimall-btn { font-size: 12px; color: #67c23a; cursor: pointer; }
.letter-list { max-height: 340px; overflow-y: auto; }
.letter-item { border-bottom: 1px solid #ebeef5; padding: 8px 4px; cursor: pointer; }
.letter-item:hover { background: #f5f7fa; }
.letter-unread .letter-title { font-weight: bold; color: #303133; }
.letter-row { display: flex; align-items: center; gap: 6px; }
.letter-dot { width: 8px; height: 8px; border-radius: 4px; background: #f56c6c; display: inline-block; flex-shrink: 0; }
.letter-title { font-size: 14px; color: #606266; flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.attach-flag { font-size: 12px; flex-shrink: 0; }
.letter-from { font-size: 12px; color: #909399; flex-shrink: 0; max-width: 90px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.read-state { font-size: 11px; color: #909399; flex-shrink: 0; }
.letter-type { font-size: 11px; padding: 0 6px; border-radius: 8px; flex-shrink: 0; }
.type-system { background: #f4f4f5; color: #909399; }
.type-task { background: #f0f9eb; color: #67c23a; }
.type-trade { background: #fdf6ec; color: #e6a23c; }
.type-player { background: #ecf5ff; color: #409eff; }
.letter-content { font-size: 13px; color: #606266; padding: 6px 2px 2px 14px; white-space: pre-wrap; }
.letter-time { font-size: 11px; color: #c0c4cc; margin-top: 2px; }
.letter-page { text-align: center; margin-top: 10px; }
.page-num { font-size: 12px; color: #909399; margin: 0 8px; }
.noSelected { text-align: center; color: #909399; padding: 30px 0; }
/* 附件 */
.attach-box { margin: 6px 2px 2px 14px; padding: 6px; background: #f8f9fb; border-radius: 4px; }
.attach-title { font-size: 12px; color: #909399; margin-bottom: 4px; }
.attach-item { display: flex; align-items: center; gap: 6px; padding: 3px 0; }
.attach-item img { width: 28px; height: 28px; }
.attach-name { font-size: 13px; color: #606266; flex: 1; }
.attach-name i { font-style: normal; color: #e6a23c; }
.attach-claim-row { margin-top: 5px; text-align: right; }
.attach-claim { font-size: 12px; color: #67c23a; cursor: pointer; }
.attach-claimed { font-size: 12px; color: #c0c4cc; }
/* 写信 */
.write-box { padding-top: 4px; }
.write-row { display: flex; align-items: center; margin-bottom: 8px; }
.write-label { font-size: 13px; color: #606266; flex-shrink: 0; }
.write-friend { width: 200px; }
.write-input { width: 320px; }
.write-content { margin-bottom: 8px; }
.attach-select { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin-bottom: 10px; }
.attach-add-btn { font-size: 12px; color: #409eff; cursor: pointer; }
.attach-chip { display: inline-flex; align-items: center; gap: 3px; font-size: 12px; color: #606266;
  background: #f4f4f5; border-radius: 10px; padding: 2px 8px; }
.attach-chip img { width: 20px; height: 20px; }
.attach-chip i { font-style: normal; color: #e6a23c; }
.chip-del { color: #f56c6c; cursor: pointer; margin-left: 2px; }
.write-actions { text-align: right; }
/* 附件选择弹窗 */
.picker-grid { display: flex; flex-wrap: wrap; gap: 8px; max-height: 320px; overflow-y: auto; min-height: 80px; }
.picker-item { width: 60px; text-align: center; cursor: pointer; border: 2px solid transparent; border-radius: 4px; padding: 4px 2px; position: relative; }
.picker-item:hover { background: #f5f7fa; }
.picker-item.picked { border-color: #409eff; background: #ecf5ff; }
.picker-item.disabled { opacity: 0.4; cursor: not-allowed; }
.picker-item img { width: 36px; height: 36px; }
.picker-name { font-size: 11px; color: #606266; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.picker-count { position: absolute; top: 0; right: 4px; font-size: 11px; color: #e6a23c; }
.picker-actions { text-align: right; margin-top: 8px; }
@media (max-width: 768px) {
  .letterwrap .el-dialog { width: 92% !important; margin-top: 8vh !important; }
  .letter-list { max-height: calc(60vh - 50px); }
  .write-input { width: 220px; }
  .picker-grid { max-height: calc(50vh - 60px); }
}
</style>
